import api from '../api/api';
import { getErrorMessage, requiresReauth } from '../utils/errorMessages';

class AdviceService {
  static async generateAdvice(data) {
    try {
      const response = await api.post('/api/advice/generate', data);
      return response.data;
    } catch (error) {
      console.error('Generate advice error:', error);
      
      // Check for quota exceeded
      if (error.response?.data?.quotaExceeded || error.response?.data?.code === 'QUOTA_EXCEEDED') {
        throw { ...error.response.data, quotaExceeded: true };
      }
      
      // Check if reauthentication is required
      if (requiresReauth(error)) {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
      
      // Use centralized error message handling
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  }

  static async getUsageStats() {
    try {
      const response = await api.get('/api/advice/usage');
      return response.data;
    } catch (error) {
      console.error('Usage stats error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  }

  static async checkHealth() {
    try {
      const response = await api.get('/api/health');
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      return { 
        status: 'ERROR',
        message: 'サーバーとの接続に問題があります。'
      };
    }
  }
}

export default AdviceService;